<template lang="pug">
.page.container(v-if='sprite')
  .row
    .col-12.col-md-4
      .sprite-wrapper
        sprite-render.sprite(:sprite='sprite', size='large', :class="{bounce: tokenId, freeType: !tokenId}")
        img.island(v-if='!readyToEvolve', src='../../assets/island-1@3x.png')
    .col-12.col-md-8
      .tabs.d-flex.justify-content-center
        .tab(:class='{active: page === "detail"}', @click='page = "detail"') Detail
        .tab(:class='{active: page === "activity"}', @click='page = "activity"') Activity
      .card-wrapper
        .details-wrap(v-if='page === "detail"')
          div.d-flex.justify-content-between
            sprite-name-display(:sprite='sprite')
            .favorite(v-if='!favorited', @click='favorite()')
              b-tooltip(target="notfavorite", title="Set as buddy sprite.")
              svg#notfavorite(xmlns='http://www.w3.org/2000/svg', width='25', height='24', viewbox='0 0 25 24')
                path(fill-rule='evenodd', d='M12.5 20.431L4.775 24l.975-8.52L0 9.168l8.328-1.696L12.5 0l4.172 7.471L25 9.167l-5.75 6.314.975 8.519z')
            .favorite(v-else, @click='favorite()')
              b-tooltip(target="favorite", title="Buddy Sprite")
              svg#favorite(xmlns='http://www.w3.org/2000/svg', width='25', height='24', viewbox='0 0 25 24')
                path(fill-rule='evenodd', d='M12.5 20.431L4.775 24l.975-8.52L0 9.168l8.328-1.696L12.5 0l4.172 7.471L25 9.167l-5.75 6.314.975 8.519z')
          .attributes.d-flex
            .pill-item.green Forest
            .pill-item Timid
            .pill-item Adult
            .pill-item(v-if='tokenId') {{ `#${tokenId}` }}
          .level {{ `Level ${sprite.level}` }}
          // @TODO: Abstract to component
          .progress-wrap.d-flex.align-items-center
            .progress-item.d-flex.align-items-center
              .exp-title.d-flex.align-items-center.justify-content-center
                span Exp
              .exp-bar-wrap.d-flex.align-items-center
                .exp-fill(:style="{width: `${expPercent}%`}")
            .exp-list {{ spriteExp - expToPrevLevel }} / {{ expToNextLevel - expToPrevLevel }}
          .feature-title.d-flex.align-items-center
            h3 Feature Slots
            .line.hr
          .slot.d-flex.align-items-center
            .icon.d-flex.align-items-center.justify-content-center
              img(src="../../assets/sprite-page/egg.svg")
            .details
              .title Egg Group
              .detail Forest
          .slot.d-flex.align-items-center
            .icon.d-flex.align-items-center.justify-content-center
              img(src="../../assets/sprite-page/fill.svg")
            .details
              .title Sprite Type
              .detail Foliage Walker
          .slot.d-flex.align-items-center
            .icon.d-flex.align-items-center.justify-content-center
              img(src="../../assets/sprite-page/alignment.svg")
            .details
              .title Alignment
              .detail Fall
          .slot.d-flex.align-items-center
            .icon.d-flex.align-items-center.justify-content-center
              img(src="../../assets/sprite-page/crown.svg")
            .details
              .title Hierarchy
              .detail Commoner
        .activity-wrap(v-if='page === "activity"')
          .empty-wrap(v-if='sprite.recentActivity.length === 0')
            img(src='../../assets/metamask/hiding-sprite.svg')
            h4 Nothing here yet. Try adding this Sprite to an Event
          activity-list(:activity='sprite.recentActivity')
</template>

<style lang="scss" scoped>
  @media (max-width: 991.98px) {
    .sprite-wrapper {
      margin-top: 4rem !important;
    }
  }

  .sprite-wrapper {
    margin-top: 15rem;
    position: relative;

    @keyframes bounce {
      0% {
        transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
      }
      50% {
        transform: translate3d(0,-2px,0) scale3d(.98, 1.02, 1);
      }
      100% {
        transform: translate3d(0,8px,0) scale3d(1.02,.92,1);
      }
    }

    .bounce {
      transform-origin: 50% 50%;
      animation: bounce .35s ease alternate infinite;
      top: 40px;
      max-height: 200px;
      margin-bottom: -.5rem;
    }

    @keyframes MoveUpDown {
      0%, 100% {
        top: 2.5rem;
      }
      50% {
        margin-bottom: 1rem;
      }
    }

    .freeType {
      margin-bottom: 2.5rem;
      animation: MoveUpDown 2s ease infinite;
    }

    .island {
      width: 80%;
      margin-top: -4rem;
      z-index: -1;
      position: relative;
    }
  }

  .details-wrap {
    padding: 1rem;
  }

  .attributes {
    margin-top: 1rem;
    margin-left: .8rem;

    .pill-item {
      border-radius: 999px;
      border: solid 2px #a1a39e;
      margin-left: .5rem;
      width: 61px;
      height: 24px;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
    }

    .pill-item.green {
      border: solid 2px #9bc75a;
      color: #9bc75a;
    }
  }

  .level {
    margin-top: 2rem;
    margin-left: 1.5rem;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #6c6d69;
  }

  .tabs {
    margin-top: 4rem;
  }

  .card-wrapper {
    margin: 0 auto;
    margin-top: 2rem;
    min-height: 624px;
    max-width: 588px;
    padding: 1rem;
    border-radius: 16px;
    background-image: linear-gradient(to bottom, #ffffff, #f7f8f6);
  }

  .activity-wrap {
    .empty-wrap {
      height: 100%;
      margin-top: 8rem;

      h4 {
        margin-top: 1rem;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: #a1a39e;
        line-height: 1.43;
        font-size: 14px;
      }
    }
  }

  .favorite {
    cursor: pointer;

    svg {
      fill: #E7E9E4;
    }

    svg:hover {
      fill: #A1A39E;
    }

    #favorite {
      fill: #EEA830;
    }
  }

  .feature-title {
    margin-top: 1.5rem;

    h3 {
      margin-left: 1.5rem;
      margin-bottom: 0;
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #363734;
    }

    .line {
      margin-top: 1rem;
    }

    .hr {
      margin: 0 auto;
      width: 370px;
      height: 1px;
      background-color: #e7e9e4;
    }
  }

  .slot {
    margin-top: 2rem;
    margin-left: 1.5rem;

    .icon {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      background-color: #e7e9e4;
    }

    .details {
      margin-left: 1rem;
      text-align: left;
    }

    .title {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #a1a39e;
    }

    .detail {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #6c6d69;
    }
  }

  // @TODO: Abstract
  .progress-wrap {
    position: relative;
    margin-top: .5rem;
  }

  .progress-item {
    width: 100%;
    max-width: 375px;
    height: 24px;
    border-radius: 999px;
    background-color: #e7e9e4;
    margin-left: 1.5rem;
  }

  .exp-title {
    width: 18%;
    height: 100%;
    background: #9bc75a;
    border-radius: 10px 0px 0px 10px;
    margin-right: .2rem;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #f7f8f6;
    text-align: center;
    padding-top: .1rem;
  }

  .exp-bar-wrap {
    width: 80%;
    height: 16px;
    padding-left: .2rem;
    padding-right: .2rem;
    border-radius: 999px;
    background-color: #ffffff;
  }

  .exp-fill {
    width: 84px;
    max-width: 100%;
    height: 10px;
    border-radius: 999px;
    background-color: #9bc75a;
  }

  .exp-list {
    margin-left: .5rem;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #9bc75a;
  }
</style>

<script>
import axios from 'axios';

import ActivityList from '../activity/ActivityList';
import SpriteRender from './SpriteRender';
import SpriteNameDisplay from './SpriteNameDisplay';
import spriteStats from '../../mixins/spriteStats';
import evolveMixin from '../../mixins/evolve';

export default {
  mixins: [spriteStats, evolveMixin],
  components: {
    SpriteRender,
    SpriteNameDisplay,
    ActivityList,
  },
  data() {
    return {
      page: 'detail',
      size: 'large', // @TODO: This is a hack to only display evolve here
    };
  },
  async mounted() {
    // @TODO: Use api
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    window.amplitude.getInstance().logEvent('VIEW_SPRITE_DETAIL');

    if (!this.sprite) {
      const sprite = await axios.get(`/sprites/${this.$route.params.spriteId}`);
      this.usersMonsters.push(sprite);
    }
  },
  computed: {
    favorited() {
      return this.$store.state.favoriteMonster._id === this.$route.params.spriteId;
    },
    usersMonsters() {
      return this.$store.state.usersMonsters;
    },
    sprite() {
      return this.usersMonsters.find(sprite => sprite._id === this.$route.params.spriteId);
    },
  },
  methods: {
    async favorite() {
      // @TODO: Move to action
      await axios.post(`/sprites/${this.sprite._id}/favorite`);
      this.$store.commit('favoriteMonster', { monster: this.sprite });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpritePage.vue